import React from 'react';

export default function EmployeeSearchBar({ search, setSearch, onShowAdvanced, onSearchChange }) {
  return (
    <div className="flex items-center gap-2 w-full min-w-0 max-w-full sm:max-w-[400px]">
      <div className="form-field w-full relative">
        <input
          type="text"
          placeholder="Search employees..."
          value={search}
          onChange={(e) => {
            const value = e.target.value;
            setSearch(value);
            onSearchChange(value);
          }}
          className="w-full !pr-[172px] border rounded focus:outline-none focus:border-gray-500"
          required
        />
        {/* Clear (X) Button */}
        {search && (
          <button
            type="button"
            onClick={() => {
              setSearch('');
              onSearchChange();
            }}
            className="absolute right-[155px] top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
        {/* Divider as vertical line */}
        <div className="absolute right-[147px] top-1/2 transform -translate-y-1/2 h-5 border-l border-gray-300" />
        {/* Filter Icon + Label */}
        <button
          type="button"
          onClick={onShowAdvanced}
          className="absolute flex flex-row gap-2 right-2 top-1/2 transform -translate-y-1/2 text-[#A9A9A9] hover:text-[#808080] transition-all duration-300"
          title="Advanced Search"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="6" y1="3" x2="6" y2="21" />
            <circle cx="6" cy="7" r="2" />
            <line x1="12" y1="3" x2="12" y2="21" />
            <circle cx="12" cy="17" r="2" />
            <line x1="18" y1="3" x2="18" y2="21" />
            <circle cx="18" cy="12" r="2" />
          </svg>
          <span className="text-[0.9rem] hidden sm:inline">Advanced Search</span>
        </button>
      </div>
    </div>
  );
} 